export default {
  'menu.aiScenes': '应用场景',
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.myApps': '我的应用',
  'menu.markets.apps': '应用市场',
  'menu.markets.skills': 'Skill 市场',
  'menu.markets.mcp': 'MCP 市场',
  'menu.markets.plugins': '插件市场',
  'menu.businessAppMarket': '业务应用市场',
  'menu.management': '企业管理',
  'menu.management.tenants': '租户管理',
  'menu.management.tenantDetail': '租户详情',
  'menu.management.users': '用户管理',
  'menu.management.userDetail': '用户详情',
  'menu.management.myTenants': '租户设置',
  'menu.management.myTenantDetail': '租户设置',
  'menu.management.identities': '成员管理',
  'menu.management.departments': '部门管理',
  'menu.management.roles': '权限管理',
  'menu.management.auditLog': '审计日志',
  'menu.platformManagement': '平台管理',
  'menu.platformManagement.applications': '应用管理',
  'menu.platformManagement.pluginApplications': '插件应用',
  'menu.platformManagement.applicationPublicationReview': '应用上架审核',
  'menu.platformManagement.taxonomies': '分类法管理',
  'menu.platformManagement.aiRuntime': '模型广场',
  'menu.platformManagement.events': '事件引擎',
  'menu.platformManagement.clusters': '集群管理',
  'menu.platformManagement.applicationStorage': '应用存储配置',
  'menu.platformManagement.productCatalog': '统一商品目录',
  'menu.platformManagement.tenantPackages': '套餐管理',
  'menu.platformManagement.tenantEntitlements': '租户权益',
  'menu.platformManagement.paymentOrders': '支付订单',
  'menu.platformSettings': '平台设置',
  'menu.platformSettings.branding': '品牌',
  'menu.platformSettings.llm': '默认大模型',
  'menu.platformSettings.storage': '默认存储',
  'menu.platformSettings.quota': '用量限制',
  'menu.platformSettings.features': '平台功能',
  'menu.platformSettings.permissions': '平台权限',
  'menu.admin': '管理页',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.account.switchTenant': '切换企业',
  'menu.account.switchTenant.empty': '暂无可切换企业',
  'menu.account.switchTenant.create': '创建/加入企业',
  'menu.account.switchTenant.delete': '删除企业',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
